import { createSlice } from '@reduxjs/toolkit';

const initialState = { data: null, status: 'idle', error: null };

const getInvitesSlice = createSlice({
  name: 'getInvites',
  initialState,
  reducers: {
    getInvitesRequest(state) {
      state.status = 'loading';
      state.error = null;
    },
    getInvitesSuccess(state, action) {
      state.status = 'succeeded';
      state.data = action.payload;
    },
    getInvitesFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
    getInvitesReset(state) {
      state.status = 'idle';
      state.error = null;
      state.data = null;
    },
  },
});

export const getInvitesAction = getInvitesSlice.actions;
export default getInvitesSlice;